module.exports = __webpack_public_path__ + "static/wellness-d6e12a83202dc5a7038462267a1243d9.png";